export default __webpack_public_path__ + "vision-overview-header-image-1200-e76b9eda64a6c010488b9545df8be49f.webp";